<template>
  <div class="columns">
    <div class="column is-12">
      <div
        :style="`height: ${
          protractor.styles.height / 2 + 50
        }px; overflow-y: hidden; padding: 5px 25px 0px 25px;`"
      >
        <div
          id="protractor"
          :style="protractorStyles"
          @mousemove="mouseEvents"
          @mousedown="mouseStart"
        >
          <div
            id="angle"
            v-if="!protractor.is_angle_hidden"
            :style="lineStylesStable"
          >
            <span :style="arrowStyles"> </span>
          </div>
          <div
            id="angle"
            v-if="!protractor.is_angle_hidden"
            :style="lineStyles"
          >
            <div :style="dragStyles" v-if="protractor.is_user_selectable">
              <span id="noselect">{{
                this.dynamicAngle(this.modifiedAngle)
              }}</span>
            </div>
            <span :style="arrowStyles"> </span>
          </div>
          <div
            id="pivot"
            :style="`background: ${protractor.arrow_styles.bg_color}`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";
import { mapActions } from "vuex";
import { protractor_templates } from "./utils";
export default {
  name: "show-protractor",
  props: {
    protractor: {
      type: Object,
    },
  },
  watch: {
    protractor: {
      handler: function (new_val) {
        this.modifiedAngle = this.dynamicAngle(new_val.angle);
      },
      deep: true,
    },
    modifiedAngle(new_val) {
      let is_correct = false;
      this.dynamicAngle(new_val)===this.protractor.answer_angle?is_correct = true : is_correct = false;
      this.updateCurrentAnswer({ key : "protractor", value : is_correct })
    },
  },
  computed: {
    relativeAngle() {
      return this.protractor.angle_direction === "C" ? 0 : 180;
    },
    ProtractorDegrees() {
	let angle =
	this.modifiedAngle && this.modifiedAngle >= 0
		? this.modifiedAngle - 90
		: -90;
	angle = angle >= 180 ? 90 : angle;
	return angle;
    },
    ProtractorRelativeDegrees() {
      let angle =
        this.relativeAngle && this.relativeAngle >= 0
          ? this.relativeAngle - 90
          : -90;
      angle = angle >= 180 ? 90 : angle;
      return angle;
    },
    lineStyles() {
      let styles = {};
      if (this.protractor && this.protractor.arrow_styles) {
        styles = getCSSFromStyles(this.protractor.arrow_styles);
      }
      styles["transform"] = `rotate(${this.ProtractorDegrees}deg)`;
      styles["left"] = "49.8%";
      return styles;
    },
    dragStyles() {
      let styles = {};
      let bg_color = getCSSFromStyles(this.protractor.arrow_styles)[
        "background-color"
      ];
      styles["transform"] = `rotate(0deg)`;
      styles["width"] = "50px";
      styles["height"] = "20px";
      styles["color"] = "white";
      styles["text-align"] = "center";
      styles["border-radius"] = "20px";
      styles["margin-top"] = "-24px";
      styles["margin-left"] = "-24px";
      styles["background-color"] = `${bg_color}`;
      return styles;
    },
    lineStylesStable() {
      let styles = {};
      if (this.protractor && this.protractor.arrow_styles) {
        styles = getCSSFromStyles(this.protractor.arrow_styles);
      }
      styles["transform"] = `rotate(${this.ProtractorRelativeDegrees}deg)`;
      styles["left"] = "49.8%";
      return styles;
    },
    arrowStyles() {
      let styles = {};
      let bg_color = getCSSFromStyles(this.protractor.arrow_styles)[
        "background-color"
      ];
      styles["top"] = "0";
      styles["left"] = `-${
        getCSSFromStyles(this.protractor.arrow_styles).width
      }`;
      styles["transform"] = `rotate(225deg)`;
      styles["-webkit-transform"] = `rotate(225deg)`;
      styles["border-style"] = `solid`;
      styles["border-color"] = `${bg_color}`;
      styles["border-image"] = `initial`;
      styles["border-width"] = `0px ${
        getCSSFromStyles(this.protractor.arrow_styles).width
      } ${getCSSFromStyles(this.protractor.arrow_styles).width} 0px`;
      styles["position"] = "absolute";
      styles["padding"] = getCSSFromStyles(this.protractor.arrow_styles).width;
      return styles;
    },
    protractorStyles() {
      let styles = {};
      if (this.protractor && this.protractor.styles) {
        styles = getCSSFromStyles(this.protractor.styles);
        styles["border-radius"] = "50%";
      }

      // Adding background based on selection
      if (this.protractor.template) {
        const current_protractor_template = protractor_templates.find(
          (template) => {
            return template.id == this.protractor.template;
          }
        );

        if (current_protractor_template) {
          styles[
            "background-image"
          ] = `url('${current_protractor_template.img}')`;
          styles["border-radius"] = "50%";
        }
      }
      return styles;
    },
    // BarColor(){
    // 	let color = this.bar.color;
    // 	return color
    // }
  },
  data() {
    return {
      dragging: false,
      is_Correct: false,
      modifiedAngle: 0,
    };
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    mouseStart() {
      this.dragging = true;
    },
    mouseStop() {
      this.dragging = false;
    },
    mouseEvents(e) {
      if (this.protractor.is_user_selectable && this.dragging) {
        var offsets = document
          .getElementById("protractor")
          .getBoundingClientRect();
        var x_coord = e.clientX - offsets.left;
        var y_coord = e.clientY - offsets.top;
        var radius = parseInt(
          getCSSFromStyles(this.protractor.arrow_styles).height
        );
        this.modifiedAngle = parseInt(
          Math.round(this.findAngle(x_coord, y_coord, radius, radius))
        );
      }
    },
    findAngle(cx, cy, ex, ey) {
      var dy = ey - cy;
      var dx = ex - cx;
      var theta = Math.atan2(dy, dx);
      theta *= 180 / Math.PI;
      return theta;
    },
    dynamicAngle(angle) {
      return parseInt(this.relativeAngle) ? 180 - angle : angle;
    },
  },
  mounted() {
	this.modifiedAngle = this.dynamicAngle(this.protractor.angle);
    window.addEventListener("mouseup", this.mouseStop);
  },
};
</script>
<style scoped>
#protractor {
  position: relative;
  background: url("https://i.postimg.cc/TPkGkrMg/Protractor-05.png") no-repeat;
  background-size: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

#angle {
  position: absolute;
  background: rgb(0, 0, 0);
  transform-origin: bottom;
  top: 0%;
  bottom: 50%;
  left: 48.85%;
  opacity: 0.8;
  /* transform: rotate(-90deg); */
}

#pivot {
  width: 5%;
  height: 5%;
  border-radius: 50%;
}

#noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>